const BASE_URL = "https://prod-edx-video-transcripts.edx-video.net";

const getTranscriptionUrl = (videoId: string, langCode: string): string => {
  return `${BASE_URL}/about-video-transcripts/${videoId}-${langCode}.vtt`;
};

export default getTranscriptionUrl;
